import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { pagesKey } from '@dashboard/lib/queryKeys';
import usePageQueries from '@dashboard/hooks/queries/usePageQueries';
import DialogOld from './DialogOld';
import Description from './Description';
import Form from './Formik/Form';

const EditCheckoutNameDialog = ({ isOpen, onClose, checkout }) => {
  const { updatePage } = usePageQueries();
  const queryClient = useQueryClient();

  return (
    <DialogOld isOpen={isOpen} onClose={onClose} title="Edit name">
      <Description>For your reference. Not shown to customers.</Description>

      <div className="h-full flex-1 flex flex-col mt-2">
        <Form
          showState={false}
          initialValues={{
            name: checkout.name,
          }}
          onSubmit={async (values, actions) => {
            try {
              const response = await updatePage(
                {
                  name: values.name,
                },
                checkout._id,
              );

              onClose();

              actions.resetForm();

              queryClient.invalidateQueries({ queryKey: pagesKey });

              return {
                data: {
                  name: response.data.name,
                },
              };
            } catch (err) {
              return {
                error: err.message,
              };
            }
          }}
          fields={[
            {
              name: 'name',
              label: 'Name',
              required: true,
            },
          ]}
          submitButton={{
            label: 'Save',
            size: 'full',
          }}
        />
      </div>
    </DialogOld>
  );
};

export default EditCheckoutNameDialog;
